import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import clsx from 'clsx';
import { SkeletonPlaceholder } from '../Skeleton/SkeletonPlaceholder';
import { DeprecatedButton, } from '../DeprecatedButton/DeprecatedButton';
import { BodyTextMedium, BodyTextSmall, HeadingText30, HeadingText50, } from '../Typography/Typography';
import * as styles from './ContentBanner.module.scss';
import * as typographyStyles from '../Typography/Typography.module.scss';
export var ContentBannerTestID;
(function (ContentBannerTestID) {
    ContentBannerTestID["Container"] = "ContentBannerTestID.Container";
})(ContentBannerTestID || (ContentBannerTestID = {}));
export const ContentBannerContent = ({ title, description, anchorImage = true, image, subtitle, buttonTitle, backgroundColor, onClick, linkTo, theme, buttonProps = {
    noBorder: true,
}, descriptionStartIconUrl, footer, }) => {
    const colorfulVariant = !!backgroundColor;
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const buttonAction = linkTo ? { to: linkTo } : { onClick };
    let buttonVariant;
    let fontColor;
    let descriptionFontColor;
    switch (theme) {
        case 'dark':
            fontColor = 'gray85';
            descriptionFontColor = 'gray75';
            buttonVariant = 'dark';
            break;
        case 'light':
            fontColor = 'white';
            descriptionFontColor = 'white';
            buttonVariant = 'secondary';
            break;
        default:
            if (colorfulVariant) {
                fontColor = 'white';
                descriptionFontColor = 'white';
                buttonVariant = 'primary';
            }
            else {
                fontColor = 'gray85';
                descriptionFontColor = 'gray75';
                buttonVariant = 'secondary';
            }
    }
    const TitleTextComponent = smallScreenDetected
        ? HeadingText30
        : HeadingText50;
    const SubtitleTextComponent = smallScreenDetected
        ? BodyTextSmall
        : BodyTextMedium;
    const DescriptionTextComponent = smallScreenDetected
        ? BodyTextSmall
        : BodyTextMedium;
    const displayImage = () => {
        if (!image) {
            return null;
        }
        const imageStyle = [
            styles.image,
            anchorImage ? styles.imageAnchored : undefined,
        ];
        if (typeof image === 'string') {
            // we support passing both url to image and inline svg component
            // to style them identically we have to use className
            return _jsx("img", { src: image, className: clsx(imageStyle), alt: "" });
        }
        const Image = image;
        return _jsx(Image, { className: clsx(imageStyle) });
    };
    const footerStyle = clsx([typographyStyles.body, typographyStyles.bodySm]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.textContainer, children: [subtitle && (_jsx(SubtitleTextComponent, { fontColor: fontColor, marginBottom: 10, children: subtitle })), _jsx(TitleTextComponent, { fontColor: fontColor, marginBottom: 0, children: title }), _jsxs("div", { className: styles.descriptionWrapper, children: [descriptionStartIconUrl ? (_jsx("img", { alt: "", src: descriptionStartIconUrl, className: styles.descriptionStartIcon })) : null, _jsx(DescriptionTextComponent, { fontColor: descriptionFontColor, marginBottom: 0, children: description })] }), (onClick || linkTo) && buttonTitle && (_jsx(DeprecatedButton, { title: buttonTitle, marginTop: 32, rounded: true, variant: buttonVariant, size: smallScreenDetected ? 'small' : 'medium', ...buttonProps, ...buttonAction })), footer ? _jsx("div", { className: footerStyle, children: footer }) : null] }), displayImage()] }));
};
const Name = 'ContentBanner';
export const ContentBanner = ({ className, ...props }) => {
    const { backgroundColor } = props;
    const colorfulVariant = !!backgroundColor;
    return (_jsx("div", { className: clsx(styles.container, className, !colorfulVariant && styles.containerOutlined), onDragStart: evt => evt.preventDefault(), draggable: false, style: backgroundColor ? { backgroundColor } : {}, "data-testid": ContentBannerTestID.Container, "data-component": Name, children: _jsx(ContentBannerContent, { ...props }) }));
};
export const ContentBannerSkeleton = () => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    return (_jsx(SkeletonPlaceholder, { width: "100%", height: smallScreenDetected ? 184 : '100%', borderRadius: 6 }));
};
